import React from 'react'
import withTranslations from 'support/hoc/withTranslations'
import { observer } from 'mobx-react'
import { File as BaseFile } from '@morningtrain/react-fields'

function ImageFile (props) {
  const {
    className
  } = props

  const classNames = [
    'file-wrapper',
    'file-wrapper--file',
    className
  ]

  return <BaseFile {...props} className={classNames.join(' ')}/>
}

export default observer(withTranslations(ImageFile))
